export const GITHUB_IMG_URL="https://cdn-icons-png.flaticon.com/128/3291/3291695.png";

export const LINKEDIN_IMG_URL="https://cdn-icons-png.flaticon.com/128/3536/3536505.png";

export const INSTAGRAM_IMG_URL="https://cdn-icons-png.flaticon.com/128/174/174855.png";

export const GMAIL_IMG_URL="https://cdn-icons-png.flaticon.com/128/732/732200.png";

export const Github_Api_Url="https://api.github.com/users/Kanavd55";

export const Html_logo="https://cdn-icons-png.flaticon.com/128/5968/5968267.png"

export const Css_logo="https://cdn-icons-png.flaticon.com/128/5968/5968242.png";

export const Javascript_logo="https://cdn-icons-png.flaticon.com/128/5968/5968292.png";

export const React_logo="https://cdn-icons-png.flaticon.com/128/875/875209.png"

export const Nodejs_logo="https://cdn-icons-png.flaticon.com/128/919/919825.png";

export const Expressjs_logo="https://cdn-icons-png.flaticon.com/128/15484/15484303.png";

export const MongoDB_logo="https://cdn-icons-png.flaticon.com/128/10678/10678415.png";

export const Tailwind_logo="https://cdn-icons-png.flaticon.com/128/1506/1506761.png";

export const Git_logo="https://cdn-icons-png.flaticon.com/128/4494/4494748.png";

export const Java_logo="https://cdn-icons-png.flaticon.com/128/5968/5968282.png";

export const Sql_logo="https://cdn-icons-png.flaticon.com/128/337/337953.png";

export const Linux_logo="https://cdn-icons-png.flaticon.com/128/226/226772.png"

export const MaterialUI_logo="https://cdn-icons-png.flaticon.com/128/9980/9980326.png";

export const Nextjs_logo="https://cdn-icons-png.flaticon.com/128/14018/14018798.png";

export const Redux_logo="https://cdn-icons-png.flaticon.com/128/5942/5942683.png";

export const Mail_Link='mailto:kanavdahat55@gmail.com';

export const LinkedIn_Link='https://www.linkedin.com/in/kd28/';

export const Github_Link='https://github.com/Kanavd55';
